import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { SideMenuFilterItem } from '@vlabs/monokit/shared/ui/side-menu-filter-item';

import ReferenceFilterPopover from './popovers/ReferenceFilterPopover';
import SourceFilterPopover from './popovers/SourceFilterPopover';
import StatusFilterPopover from './popovers/StatusFilterPopover';

// left-start — попап по верхнему краю триггера
const withLeftPopover = withPopover({ placement: 'left-start' });
const withSideMenuItemLeftPopover = withLeftPopover(SideMenuFilterItem);

export const StatusFilterWithLeftPopover = withSideMenuItemLeftPopover(StatusFilterPopover);
export const SourceFilterWithLeftPopover = withSideMenuItemLeftPopover(SourceFilterPopover);
export const ReferenceFilterWithLeftPopover = withSideMenuItemLeftPopover(ReferenceFilterPopover);
